function initAmbassadorForm() {
  const form = document.querySelector('form[action*="/contact"]');
  if (!form) return;

  // Prevent default HTML5 validation
  form.setAttribute("novalidate", "");

  // Error messages
  const errorMessages = {
    required: "This question is required. Please enter your response.",
    checkbox: "Please select at least one option.",
    radioBasedInUSA: "This question is required. Please select Yes or No.",
    select: "Please select the state you are primarily based in.",
    emailRequired: "Please enter your email address.",
    emailInvalid:
      "The email address format is not valid. (e.g. user@example.com)",
  };

  function validateField(field) {
    const errorElement = document.getElementById(
      field.getAttribute("aria-describedby")
    );
    if (!errorElement) return true;

    errorElement.textContent = "";
    errorElement.classList.remove("error-active");

    if (field.tagName === "TEXTAREA" && field.hasAttribute("required")) {
      if (!field.value.trim()) {
        errorElement.textContent = errorMessages.required;
        errorElement.classList.add("error-active");
        return false;
      }
    }

    if (field.tagName === "SELECT" && field.hasAttribute("required")) {
      if (!field.value) {
        errorElement.textContent = errorMessages.select;
        errorElement.classList.add("error-active");
        return false;
      }
    }

    if (field.type === "email") {
      if (!field.value.trim()) {
        errorElement.textContent = errorMessages.emailRequired;
        errorElement.classList.add("error-active");
        return false;
      }
      if (!field.validity.valid) {
        errorElement.textContent = errorMessages.emailInvalid;
        errorElement.classList.add("error-active");
        return false;
      }
    }

    return true;
  }

  function validateBasedInUSARadio() {
    const radios = form.querySelectorAll('input[name="contact[based_in_usa]"]');
    if (!radios.length) return true;

    const groupContainer = radios[0].closest("fieldset");
    const errorId = groupContainer.getAttribute("aria-describedby");
    const errorElement = document.getElementById(errorId);

    if (!errorElement) return true;

    errorElement.textContent = "";
    errorElement.classList.remove("error-active");

    const isChecked = Array.from(radios).some((radio) => radio.checked);
    if (!isChecked) {
      errorElement.textContent = errorMessages.radioBasedInUSA;
      errorElement.classList.add("error-active");
      return false;
    }

    return true;
  }

  function validateCheckboxGroup() {
    const checkboxes = form.querySelectorAll(
      'input[type="checkbox"][name^="contact[great_fit_"]'
    );
    if (!checkboxes.length) return true;

    const groupContainer = checkboxes[0].closest("fieldset");
    const errorId = groupContainer.getAttribute("aria-describedby");
    const errorElement = document.getElementById(errorId);

    if (!errorElement) return true;

    errorElement.textContent = "";
    errorElement.classList.remove("error-active");

    const isChecked = Array.from(checkboxes).some(
      (checkbox) => checkbox.checked
    );
    if (!isChecked) {
      errorElement.textContent = errorMessages.checkbox;
      errorElement.classList.add("error-active");
      return false;
    }

    return true;
  }

  // Add blur event listeners for real-time validation
  const fields = form.querySelectorAll(
    'textarea[required], select[required], input[type="email"]'
  );
  fields.forEach((field) => {
    field.addEventListener("blur", function () {
      validateField(this);
    });
  });

  const basedInUSARadios = form.querySelectorAll(
    'input[name="contact[based_in_usa]"]'
  );
  basedInUSARadios.forEach((radio) => {
    radio.addEventListener("change", function () {
      validateBasedInUSARadio();
    });
  });

  const checkboxes = form.querySelectorAll(
    'input[type="checkbox"][name^="contact[great_fit_"]'
  );
  checkboxes.forEach((checkbox) => {
    checkbox.addEventListener("change", function () {
      validateCheckboxGroup();
    });
  });

  form.addEventListener(
    "submit",
    function (e) {
      let isValid = true;

      fields.forEach((field) => {
        if (!validateField(field)) {
          isValid = false;
        }
      });

      if (!validateBasedInUSARadio()) {
        isValid = false;
      }

      if (!validateCheckboxGroup()) {
        isValid = false;
      }

      if (!isValid) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        const firstError = form.querySelector(".error-active");
        if (firstError) {
          const fieldId = firstError.id.replace("error_", "");
          const field = document.getElementById(fieldId);
          if (field) {
            field.focus();
          } else {
            // For radio/checkbox groups
            const groupContainer = form.querySelector(
              `fieldset[aria-describedby="${firstError.id}"]`
            );
            if (groupContainer) {
              const firstInput = groupContainer.querySelector("input");
              if (firstInput) firstInput.focus();
            }
          }
        }

        return false;
      }
    },
    true
  ); // Use capture phase
}

// Initialize when DOM is ready
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initAmbassadorForm);
} else {
  initAmbassadorForm();
}
